import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

// props
interface IProps {
	percent: number;
	plt?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CircleProgressBar',
  props: {
    percent: null,
    plt: null
  },
  setup(__props: any) {

const props = __props as {
	percent: number;
	plt?: string;
};



// computed
const strokeOffset = computed<number>(() => {
	const circumference = 2 * Math.PI * 45
	if (!props.percent || props.percent === 0) return circumference;
	return circumference * (1 - props.percent);
});
const pltImage = computed<string>(() => {
	switch (props.plt) {
		case 'met_dbc':
			return '/images/socials/meteora.svg';
		case 'ray_launch':
			return '/images/socials/raydium.png';
		case 'jup_studio':
			return '/images/socials/jupiter.png';
		case 'bonk_fun':
			return '/images/socials/bonk.png';
		case 'moonshot':
			return '/images/socials/moonshot.png';
		case 'pump_fun':
			return '/images/socials/pumpfun.png';
		default:
			return '';
	}
});

return { __sfc: true,props, strokeOffset, pltImage }
}

})